<template>
<div class="chapter">
<div class="inner_page">
<div class="figure">
<img alt="Demon Witch (Book Two - The Ravenscliff Series)" src="images/cover_9194.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?7e08acbf